const color = ['#0ddaefc7', '#212e3eed'];
const bgColor = 'rgba(255,255,255,0)';
export  default {color, bgColor} ;


// WEBPACK FOOTER //
// ./src/assets/data-v/config.js